/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbReferentielGridDto } from './FcbReferentielGridDto';
import {
    FcbReferentielGridDtoFromJSON,
    FcbReferentielGridDtoFromJSONTyped,
    FcbReferentielGridDtoToJSON,
} from './FcbReferentielGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbReferentielGridDtoPaginatedResults
 */
export interface FcbReferentielGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbReferentielGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbReferentielGridDto>}
     * @memberof FcbReferentielGridDtoPaginatedResults
     */
    results?: Array<FcbReferentielGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbReferentielGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbReferentielGridDtoPaginatedResults interface.
 */
export function instanceOfFcbReferentielGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbReferentielGridDtoPaginatedResultsFromJSON(json: any): FcbReferentielGridDtoPaginatedResults {
    return FcbReferentielGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbReferentielGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbReferentielGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbReferentielGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbReferentielGridDtoPaginatedResultsToJSON(value?: FcbReferentielGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbReferentielGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

